export { default as PageWithBookEditMenu } from './PageWithBookEditMenu';
